{
  "basicTerms": {
    "selectedOfTotal": "{selected}/{total} selecionados",
    "search": "Buscar",
    "summary": "Resumo",
    "insights": "Insights",
    "help": "Ajuda",
    "expand": "Expandir",
    "collapse": "Recolher",
    "menu": "Menu",
    "account": "Conta",
    "logout": "Sair",
    "signIn": "Entrar",
    "days": "Dia | Dias",
    "phone": "Telefone",
    "subscribers": "Assinante | Assinantes",
    "favorites": "Favorito | Favoritos",
    "others": "Outro | Outros",
    "yes": "Sim",
    "no": "Não",
    "locations": "Localização | Localizações",
    "active": "Ativo",
    "inactive": "Inativo",
    "all": "Todos",
    "view": "Visualizar",
    "language": "Idioma",
    "required": "Obrigatório",
    "timezone": "Fuso horário",
    "new": "Novo",
    "open": "Aberto",
    "close": "Fechar",
    "closed": "Fechado",
    "occupied": "Ocupado",
    "reserved": "Reservado",
    "enabled": "Habilitado",
    "disabled": "Desabilitado",
    "enable": "Habilitar",
    "disable": "Desabilitar",
    "print": "Imprimir",
    "download": "Baixar",
    "zoomIn": "Ampliar",
    "zoomOut": "Reduzir",
    "previous": "Anterior",
    "next": "Próximo",
    "version": "Versão",
    "setup": "Configuração",
    "caution": "Cuidado",
    "notes": "Nota | Notas",
    "add": "Adicionar",
    "remove": "Remover",
    "duration": "Duração",
    "link": "Vincular",
    "unlink": "Desvincular",
    "to": "para",
    "success": "Sucesso",
    "error": "Erro",
    "info": "Informação",
    "warning": "Aviso",
    "time": "Hora",
    "saved": "Salvo",
    "forms": "Formulário | Formulários",
    "is": "é",
    "only": "Somente",
    "saving": "Salvando",
    "text": "texto",
    "zip": "CEP",
    "spreadsheet": "planilha",
    "image": "Imagem",
    "cloning": "Clonando",
    "clone": "Clonar",
    "added": "Adicionado",
    "removed": "Removido",
    "planned": "Planejado",
    "unplanned": "Não planejado",
    "checkedIn": "Check-in realizado",
    "checkedOut": "Check-out realizado",
    "more": "Mais",
    "okay": "Ok",
    "reschedule": "Reagendar",
    "results": "Resultado | Resultados",
    "none": "Nenhum",
    "pages": "Página | Páginas",
    "pageOfTotal": "Página {current} de {total}",
    "of": "de",
    "default": "Padrão",
    "soon": "em breve",
    "grid": "Grade",
    "list": "Lista",
    "booked": "Reservado",
    "arrivals": "Chegada | Chegadas",
    "early": "Adiantado",
    "late": "Atrasado",
    "onTime": "No horário",
    "area": "Área | Áreas",
    "spot": "Local no pátio",
    "single": "Único",
    "multiple": "Múltiplo",
    "filter": "Filtrer",
    "board": "Quadro",
    "at": "em",
    "from": "de",
    "recent": "Recente",
    "delivered": "Entregue",
    "sent": "Enviado",
    "failed": "Falhou",
    "create": "Criar",
    "tasks": "Tarefa | Tarefas",
    "emails": "E-mail | E-mails",
    "passwords": "Senha | Senhas",
    "limits": "Limites",
    "assignee": "Responsável",
    "comment": "Comentário",
    "issue": "Problema",
    "urgent": "Urgente",
    "retry": "Tentar novamente",
    "custom": "Personalizado",
    "na": "N/D"
  },
  "phrases": {
    "updateEmail": "Atualizar e-mail",
    "copyToClipboard": "Copiar para a área de transferência",
    "copiedToClipboard": "Copiado para a área de transferência",
    "warehouseAddress": "Endereço do armazém",
    "cloneSchedule": "Clonar agenda",
    "open24Hours": "Aberto 24 horas",
    "featureEnabled": "Recurso ativado",
    "featureDisabled": "Recurso desativado",
    "learnMore": "Saiba mais",
    "minuteLabel": "{minutes} MIN",
    "minuteLabelFull": "{minutes} minutos",
    "thisActionCannotBeUndone": "esta ação NÃO PODE ser desfeita",
    "areYouSure": "Tem certeza?",
    "unknownUser": "Usuário desconhecido",
    "leaveWithoutSaving": "Sair sem salvar",
    "learnHowItWorks": "Saiba como funciona",
    "allFields": "Todos os campos",
    "selectColumns": "Selecionar colunas",
    "selectedColumns": "Colunas selecionadas",
    "addFiles": "Adicionar arquivo | Adicionar arquivos",
    "tasks": "Nenhuma tarefa | {count} tarefa | {count} tarefas",
    "driversSelfCheckin": "Auto check-in do motorista",
    "addReferenceNumber": "Adicionar número de referência",
    "myAccount": "Minha conta",
    "mustBeAValidNumber": "Deve ser um número válido"
  },
  "messages": {
    "theConfirmationFieldDoesNotSupportPasting": "O campo de confirmação não permite colar",
    "youMayHaveUnsavedChangesAreYouSureYouWantToLeaveThisPage": "Você pode ter alterações não salvas. Tem certeza de que deseja sair desta página?",
    "browserDoesNotSupportCopyFunction": "O navegador não suporta a função de copiar",
    "permissionToAccessClipboardWasDeniedToEnableAccessUpdateYourBrowserSettings": "Permissão para acessar a área de transferência foi negada. Para ativar o acesso, atualize as configurações do navegador.",
    "alternativelyYouCanManuallyCopy": "Alternativamente, você pode copiar manualmente",
    "areYouSureYouWantToLeaveYouMayHaveUnsavedChanges": "Tem certeza de que deseja sair? Você pode ter alterações não salvas.",
    "noResultsFound": "Nenhum resultado encontrado",
    "maximumOfReferenceNumbersAllowedCountRemoved": "Máximo de {maxItems} números de referência permitido. {removedCount} removido(s)"
  },
  "fileFormats": {
    "jpeg": "jpeg",
    "jpg": "jpg",
    "png": "png",
    "webp": "webp",
    "pdf": "pdf"
  },
  "specialtyTerms": {
    "opendock": "Opendock",
    "warehouses": "Armazém | Armazéns",
    "carrierContacts": "Contato do transportador | Contatos do transportador",
    "loadTypes": "Tipo de carga | Tipos de carga",
    "docks": "Doca | Docas",
    "appointments": "Agendamento | Agendamentos",
    "users": "Usuário | Usuários",
    "organizations": "Organização | Organizações",
    "orgs": "Org | Orgs",
    "companies": "Empresa | Empresas",
    "referenceNumber": "Número de referência",
    "refNumber": "Número de referência",
    "status": "Status",
    "orgLoadTypes": "Tipos de carga da organização",
    "schedulingPortal": "Portal de agendamento",
    "customFields": "campo personalizado | campos personalizados",
    "interval": "Intervalo",
    "drivers": "Motorista | Motoristas",
    "carriers": "Transportadora | Transportadoras",
    "tags": "Tag | Tags",
    "yardManagement": "Gestão de pátio",
    "carrier": "transportadora | transportadoras",
    "assets": "Ativo | Ativos",
    "tvMode": "Modo TV",
    "gridView": "Visualização em grade",
    "listView": "Visualização em lista",
    "gateManagement": "Gestão de portão",
    "selfCheckIn": "auto check-in",
    "gateFeed": "Feed do portão"
  },
  "appointmentStatuses": {
    "NoShow": "Não compareceu",
    "Cancelled": "Cancelado",
    "Requested": "Solicitado",
    "Scheduled": "Agendado",
    "Arrived": "Chegou",
    "InProgress": "Em andamento",
    "Completed": "Concluído",
    "Reserves": "Reservas"
  },
  "appointmentTypes": {
    "standard": "Padrão",
    "reserved": "Reservado",
    "reserve": "Reserva"
  },
  "appointmentCreatorTypes": {
    "warehouseUser": "Usuário do armazém",
    "carrier": "Transportadora"
  },
  "roles": {
    "base": "Básico",
    "carrier": "Transportadora",
    "carrierAdmin": "Administrador da transportadora",
    "spectator": "Espectador",
    "attendant": "Atendente",
    "operator": "Operador",
    "admin": "Administrador",
    "owner": "Proprietário",
    "internal": "Interno",
    "god": "Master"
  },
  "weekdays": {
    "sunday": "Domingo",
    "monday": "Segunda-feira",
    "tuesday": "Terça-feira",
    "wednesday": "Quarta-feira",
    "thursday": "Quinta-feira",
    "friday": "Sexta-feira",
    "saturday": "Sábado"
  },
  "weekdaysAbbr": {
    "sun": "Dom",
    "mon": "Seg",
    "tue": "Ter",
    "wed": "Qua",
    "thu": "Qui",
    "fri": "Sex",
    "sat": "Sáb"
  },
  "buttons": {
    "nevermind": "Deixa pra lá",
    "select": "Selecionar",
    "send": "Enviar",
    "confirm": "Confirmar",
    "next": "Próximo",
    "previous": "Anterior",
    "create": "Criar",
    "edit": "Editar",
    "save": "Salvar",
    "yesDelete": "Sim, excluir",
    "skipCreation": "Pular criação",
    "cancel": "Cancelar",
    "export": "Exportar",
    "saveChanges": "Salvar alterações",
    "exportData": "Exportar dados",
    "resetToDefault": "Restaurar padrão"
  },
  "tooltips": {
    "notAvailable": "Não disponível",
    "notAvailableForUserRole": "Não disponível para seu papel de usuário."
  },
  "errors": {
    "unkownError": "Ocorreu um erro desconhecido.",
    "thisFieldIsRequired": "Este campo é obrigatório",
    "passwordDoesNotMeetRequirements": "A senha não atende aos requisitos",
    "emailMustBeValid": "O e-mail deve ser válido",
    "pleaseEnterAValidPhoneNumber": "Por favor, insira um número de telefone válido",
    "pleaseEnterAValidUrl": "Por favor, insira uma URL válida",
    "invalidHour": "Hora inválida",
    "invalidMinute": "Minuto inválido",
    "pleaseSelectAmOrPm": "Selecione AM ou PM",
    "pleaseEnterACompleteDateAndTime": "Informe uma data e hora completas",
    "mustBeANumber": "Deve ser um número",
    "mustBeAPositiveInteger": "Deve ser um número inteiro positivo",
    "mustBeAWholeNumber": "Deve ser um número inteiro",
    "isNotAValidNumber": "não é um número válido",
    "isNotValid": "não é válido",
    "invalidUuid": "UUID inválido",
    "dateMustNotBeInThePast": "A data não pode estar no passado",
    "mustBeWithin24HoursOfStartTime": "deve estar dentro de 24 horas do horário de início",
    "pleaseSelectAtLeast": "Selecione pelo menos {requiredCount} {itemName} | Selecione pelo menos {requiredCount} {itemName}s",
    "cannotSelectMoreThan": "Não é possível selecionar mais de {limit} {itemName} | Não é possível selecionar mais de {limit} {itemName}s",
    "fieldMustEqual": "O campo deve ser igual a {value}",
    "mustBeXCharacters": "Deve ter {length} caractere | Deve ter {length} caracteres",
    "mustBeAtLeastXCharacters": "Deve ter pelo menos {min} caractere | Deve ter pelo menos {min} caracteres",
    "mustBeAtMostXCharacters": "Deve ter no máximo {max} caractere | Deve ter no máximo {max} caracteres",
    "mustBeBetweenXAndYCharactersLong": "Deve ter entre {min} e {max} caracteres",
    "mustBeNumberBetweenXAndY": "Deve ser um número entre {min} e {max}",
    "mustBeNumberGreaterThan": "Deve ser um número maior ou igual a {min}",
    "mustBeNumberLessThan": "Deve ser um número menor que {max}",
    "mustHaveAtLeast8Characters": "Deve ter pelo menos 8 caracteres",
    "mustContainUpperCaseAndLowerCase": "Deve conter letras maiúsculas e minúsculas",
    "mustContainAtLeastOneLetter": "Deve conter pelo menos uma letra",
    "mustContainAtLeastOneSpecialCharacter": "Deve conter pelo menos um caractere especial",
    "mustContainAtLeastOneNumber": "Deve conter pelo menos um número",
    "atLeastOneReferenceNumberIsRequired": "É necessário pelo menos um {refNumberDisplayName}",
    "mustBeAValidNumber": "Deve ser um número válido"
  },
  "warehouseAmenities": {
    "lumperServices": "Serviços de carregador",
    "overnightParking": "Estacionamento noturno",
    "driversRestroom": "Banheiro para motoristas",
    "freeWiFi": "Wi-Fi gratuito"
  },
  "warehousePPERequirements": {
    "safetyBoots": "Botas de segurança",
    "safetyGlasses": "Óculos de proteção",
    "gloves": "Luvas",
    "hardHat": "Capacete",
    "faceMask": "Máscara facial",
    "noSmoking": "Proibido fumar",
    "longPants": "Calças compridas",
    "longSleeves": "Mangas compridas",
    "highVisibilityVest": "Colete de alta visibilidade",
    "hairAndBeardNet": "Touca para cabelo e barba"
  },
  "auditLog": {
    "header": "Registro de auditoria",
    "viewAuditLog": "Ver registro de auditoria",
    "noAuditLogEvents": "Nenhum evento de auditoria",
    "printedOn": "Impresso em {date}",
    "viewDetails": "Ver detalhes",
    "snapshot": {
      "schedule": "Horário",
      "eta": "ETA",
      "emailSubscribers": "Inscritos por e-mail",
      "customFields": "Campos personalizados",
      "statusTimes": "Horários dos status"
    },
    "timelineForAllUpdatesMadeToThis": "Linha do tempo de todas as atualizações feitas neste",
    "hasTheWords": "contém as palavras",
    "eventsFromDate": "Eventos a partir da data",
    "searchEvents": "Buscar eventos",
    "by": "por",
    "appointmentUpdatesTimeline": "Histórico de atualizações do agendamento:",
    "moreUpdates": "mais {count} atualizações",
    "emailSubscribersUpdated": "Assinantes de email atualizados",
    "detailsUpdated": "Detalhes atualizados",
    "recurrenceCreated": "Recorrência criada",
    "recurrenceDeleted": "Recorrência excluída",
    "rescheduled": "{label} reagendado | {label} reagendada",
    "etaUpdated": "ETA atualizado",
    "emailNotifications": "Notificações de email",
    "carrierContactUpdated": "Contato do transportador atualizado",
    "reserveTransferred": "Reserva transferida",
    "tagsUpdated": "Tags Atualizadas",
    "scheduled": "{label} agendado",
    "statusUpdated": "Status atualizado",
    "timeUpdated": "Hora de {arrived} atualizada",
    "dwellTimeUpdated": "Tempo de permanência atualizado",
    "labelWithStatus": "{label} {status}",
    "arrivedLate": "{duration} de atraso",
    "everyXAtXUntilX": "Toda {weekDays} as {endTime} até {endDate}",
    "opendockTeam": "Equipe Opendock",
    "unknownUser": "Usuário Desconhecido",
    "deleted": "Excluído",
    "hasBeenCleared": "foi limpo",
    "actionUpdated": "atualizado",
    "actionCreated": "Criado",
    "actionDeleted": "Excluído",
    "noAction": "Sem ação",
    "emptyValue": "Valor vazio"
  },
  "timeline": {
    "createdTheTask": "criou a tarefa",
    "startedTheTask": "iniciou a tarefa",
    "blockedTheTask": "bloqueou a tarefa",
    "unblockedTheTask": "desbloqueou a tarefa",
    "completedTheTask": "concluiu a tarefa",
    "cancelledTheTask": "cancelou a tarefa",
    "cancelledTheReserve": "cancelou a reserva",
    "cancelledTheReservationForSpot": "cancelou a reserva de {areaName} - {spotCode} para esta tarefa",
    "reservedSpotForThisTask": "reservou {areaName} - {spotCode} para esta tarefa",
    "reservedTheSpot": "reservou a vaga",
    "reason": "Motivo: {reason}",
    "addedA": "adicionou",
    "reportedAn": "reportou",
    "clearedThe": "resolveu",
    "flaggedTheTask": "marcou a tarefa",
    "flaggedTheTaskAs": "marcou a tarefa como",
    "unflaggedTheTask": "desmarcou a tarefa",
    "unflaggedTheTaskAs": "desmarcou a tarefa como",
    "updatedTheTask": "atualizou a tarefa",
    "removedTask": "removeu da tarefa",
    "attachments": "anexos",
    "confirmedTheLocation": "confirmou a localização",
    "reportedAsMissing": "reportou como ausente",
    "noActivityYet": "Nenhuma atividade ainda",
    "noAssignee": "Nenhum responsável",
    "failedToFetchYardTaskTimeline": "Falha ao buscar o histórico da tarefa",
    "failedToCreateComment": "Falha ao criar comentário"
  },
  "yardSpotStatusDialog": {
    "headers": {
      "actionThisSpot": "{action} esta Vaga?"
    },
    "dropDownItems": {
      "cleaning": "Limpeza",
      "underMaintenance": "Em Manutenção",
      "blockedByEquipment": "Bloqueado por Equipamento",
      "safetyInspection": "Inspeção de Segurança",
      "routineInspection": "Inspeção de Rotina",
      "reserved": "Reservado",
      "repairsNeeded": "Reparos Necessários",
      "damage": "Dano"
    },
    "labels": {
      "reason": "Motivo",
      "additionalNotes": "Notas Adicionais"
    },
    "placeholders": {
      "selectAReason": "Selecione um motivo",
      "enterAdditionalNotes": "Insira notas adicionais"
    },
    "messages": {
      "thisSpotWillRemainUnavailable": "Esta vaga permanecerá indisponível para atribuição de ativos até que seja definida como aberta novamente.",
      "thisDoorWillBeSetAsOpen": "Esta porta será definida como aberta e estará disponível novamente para atribuição de ativos.",
      "assetInTransitClosingWillBlockMove": "O ativo {assetCode} está em trânsito para esta vaga. Fechá-la impedirá que a movimentação seja concluída."
    }
  },
  "tasks": {
    "presenter": {
      "unassigned": "Não atribuído",
      "noDueDate": "Sem prazo",
      "fromAnySpot": "De qualquer vaga",
      "toAnySpot": "Para qualquer vaga",
      "anyAsset": "Qualquer ativo",
      "types": {
        "move": "Mover"
      },
      "status": {
        "toDo": "A Fazer",
        "inProgress": "Em Andamento",
        "completed": "Concluído",
        "canceled": "Cancelado"
      },
      "issue": "Problema",
      "relatedEntity": {
        "spotArea": "Área",
        "spot": "Vaga",
        "asset": "Ativo"
      }
    }
  },
  "readyForPickupNotificationDialog": {
    "title": "Notificação de Pronto para Retirada",
    "messages": {
      "body": "Envie um e-mail para os seguintes contatos informando que o ativo {assetContainerCode} está pronto para retirada em {warehouseName}.",
      "notificationSent": "Notificação enviada com sucesso.",
      "notificationFailed": "Falha ao enviar notificação. Tente novamente."
    },
    "labels": {
      "notifyTheseContacts": "Notificar estes contatos:",
      "suggestedContacts": "Contatos sugeridos:"
    },
    "buttons": {
      "skipNotification": "Pular notificação"
    }
  },
  "chipList": {
    "keys": {
      "enter": "enter",
      "tab": "tab"
    },
    "messages": {
      "pressEnterOrTabToActionEntity": "Pressione {enterKey} ou {tabKey} para {action} {entity}",
      "pressEnterOrTabToAddEmail": "Pressione {enterKey} ou {tabKey} para adicionar um email"
    },
    "placeholders": {
      "emailSubscribers": "Assinantes de Email"
    }
  }
}
